import { KbSource } from '../api/types';
import { isSafeSourceUrl } from '../lib/sanitize';

export function Sources({ sources }: { sources: KbSource[] }) {
  const safe = sources.filter(s => isSafeSourceUrl(s.url)).slice(0, 3);
  if (safe.length === 0) return null;

  return (
    <div class="aj-msg__sources">
      <span class="aj-msg__sources-label">Sources</span>
      {safe.map(source => (
        <a
          key={source.url}
          class="aj-msg__source"
          href={source.url}
          target="_blank"
          rel="noopener noreferrer"
          title={source.url}
        >
          {source.title}
        </a>
      ))}
    </div>
  );
}
